/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// onPreRouteUpdate() and onRouteUpdate() are called before onInitialClientRender,
// use initialized flag to ensure that window.onGatsbyPreRouteUpdate() and
// window.onGatsbyRouteUpdate() will not be called before
// window.onGatsbyInitialClientRender() has run

import "./src/styles/global.css";
import { I18nProvider, LOCALES } from "./src/i18n";

let initialized = false;

export const wrapPageElement = ({ element, props }) => {
  const lang = props.pageContext?.lang;
  const locale = lang === "fr" ? LOCALES.FRENCH : LOCALES.ENGLISH;
  return <I18nProvider locale={locale}>{element}</I18nProvider>;
};

export const onInitialClientRender = () => {
  initialized = true;
  if (
    "onGatsbyInitialClientRender" in window &&
    typeof window.onGatsbyInitialClientRender === "function"
  ) {
    window.onGatsbyInitialClientRender();
  }
  if (
    "onGatsbyRouteUpdate" in window &&
    typeof window.onGatsbyRouteUpdate === "function"
  ) {
    window.onGatsbyRouteUpdate();
  }
};

export const onRouteUpdate = () => {
  if (
    initialized &&
    "onGatsbyRouteUpdate" in window &&
    typeof window.onGatsbyRouteUpdate === "function"
  ) {
    window.onGatsbyRouteUpdate();
  }
};

export const onPreRouteUpdate = () => {
  if (
    initialized &&
    "onGatsbyPreRouteUpdate" in window &&
    typeof window.onGatsbyPreRouteUpdate === "function"
  ) {
    window.onGatsbyPreRouteUpdate();
  }
};
